import React, { useState } from "react";
import { createHtmlTemplate } from '../api/TemplateService';
import { sendHtmlEmail } from '../api/emailapi.js';
import { 
  FaMapMarkerAlt, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaClock, 
  FaUser, 
  FaComment,
  FaWhatsapp,
  FaPaperPlane
} from "react-icons/fa";

const ContactSection = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: ""
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Phone numbers array
  const phoneNumbers = ["+919628362187", "+917275370808", "+917607094014"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(async () => {
      const generatedHtml = createHtmlTemplate(formData);
      try {
        const result = await sendHtmlEmail(
          "rdsnursing@gmail.com", 
          "New Lead Alert", 
          generatedHtml
        );
        
        if (result.success) {
          console.log("Email Dispatched successfully.");
        }
      } catch (err) {
        console.error("Failed to send lead.");
      }

      setIsSubmitting(false);
      setShowSuccess(true);
      
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        message: ""
      });
      
      setTimeout(() => setShowSuccess(false), 3000);
    }, 1000);
  };

  return (
    <section className="py-12 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
            Contact Us
          </h2>
          <p className="text-gray-600">
            Get in touch with us for any queries
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {/* Multiple Phone Numbers */}
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-blue-100 p-3 rounded-full">
                <FaPhoneAlt className="text-blue-600" />
              </div>
              <div>
                <p className="text-sm text-gray-500">Call Us</p>
                <p className="font-semibold">24/7 Support</p>
              </div>
            </div>
            <div className="space-y-2">
              {phoneNumbers.map((phone, index) => (
                <a 
                  key={index}
                  href={`tel:${phone}`}
                  className="block text-blue-600 hover:text-blue-800 text-sm"
                >
                  {phone}
                </a>
              ))}
            </div>
          </div>

          {/* WhatsApp - using first number */}
          <a 
            href={`https://wa.me/${phoneNumbers[0].replace('+', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="bg-green-100 p-3 rounded-full">
              <FaWhatsapp className="text-green-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">WhatsApp</p>
              <p className="font-semibold">Chat with us</p>
            </div>
          </a>
          
          {/* Email */}
          <a 
            href="mailto:rdsnursing@gmail.com"
            className="flex items-center gap-3 bg-white p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="bg-purple-100 p-3 rounded-full">
              <FaEnvelope className="text-purple-600" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Email</p>
              <p className="font-semibold">rdsnursing@gmail.com</p>
            </div>
          </a>
        </div>
        
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="bg-blue-600 p-6 text-white">
              <h3 className="text-xl font-bold mb-4">Contact Information</h3>
              <div className="flex gap-3 mb-4">
                <FaMapMarkerAlt className="text-xl mt-1" />
                <div>
                  <p className="font-medium mb-1">Campus Location</p>
                  <p className="text-sm text-blue-100">
                    Village - Kushnow, Post - Bhaupur<br />
                    District - Jaunpur, Pin - 222136<br />
                    Uttar Pradesh
                  </p>
                </div>
              </div>
              <div className="flex gap-3 mb-4">
                <FaPhoneAlt className="text-xl mt-1" />
                <div>
                  <p className="font-medium mb-1">Phone Numbers</p>
                  {phoneNumbers.map((phone, index) => (
                    <a 
                      key={index}
                      href={`tel:${phone}`}
                      className="text-sm text-blue-100 hover:text-white block mb-1"
                    >
                      {phone}
                    </a>
                  ))}
                </div>
              </div>
              <div className="flex gap-3 mb-4">
                <FaClock className="text-xl mt-1" />
                <div>
                  <p className="font-medium mb-1">Office Hours</p>
                  <p className="text-sm text-blue-100">Mon-Fri: 9:00 AM - 6:00 PM</p>
                  <p className="text-sm text-blue-100">Saturday: 9:00 AM - 4:00 PM</p>
                  <p className="text-sm text-blue-100">Sunday: Closed</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mt-6">
                <div className="bg-blue-500 rounded-lg p-3 text-center">
                  <p className="text-2xl font-bold">24/7</p>
                  <p className="text-xs">Support</p>
                </div>
                <div className="bg-blue-500 rounded-lg p-3 text-center">
                  <p className="text-2xl font-bold">&lt; 4h</p>
                  <p className="text-xs">Response</p>
                </div>
              </div>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-gray-800 mb-4">Send Message</h3>
              {showSuccess && (
                <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-green-700 text-sm">
                  Message sent successfully! We'll contact you soon.
                </div>
              )}
              
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Full Name
                  </label>
                  <div className="relative">
                    <FaUser className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                      placeholder="Enter your name"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <div className="relative">
                    <FaEnvelope className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                      placeholder="Enter your email"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number
                  </label>
                  <div className="relative">
                    <FaPhoneAlt className="absolute left-3 top-3 text-gray-400" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                      placeholder="Enter your phone"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Message
                  </label>
                  <div className="relative">
                    <FaComment className="absolute left-3 top-3 text-gray-400" />
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="3"
                      className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                      placeholder="Your message"
                    ></textarea>
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-blue-600 text-white py-2.5 rounded-lg font-medium hover:bg-blue-700 transition-colors disabled:bg-blue-300 flex items-center justify-center gap-2"
                >
                  {isSubmitting ? (
                    "Sending..."
                  ) : (
                    <>
                      Send Message
                      <FaPaperPlane className="text-sm" />
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="mt-6 rounded-lg overflow-hidden h-80 w-full shadow-md">
          <iframe
            title="RDS Nursing Campus Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28877.58729602594!2d82.6860377!3d25.7528323!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39901bae5c8d4a5f%3A0x2c5b8e9c4f5e3d7a!2sKushnow%2C%20Uttar%20Pradesh%20222136!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;